import React from "react";
import { Navigation } from "react-minimal-side-navigation";
import "react-minimal-side-navigation/lib/ReactMinimalSideNavigation.css";
import {
  FaUserGraduate,
  FaUsers,
  FaTachometerAlt,
  FaCalendarAlt,
  FaIdBadge,
  FaDiceD6,
  FaWpforms,
  FaInbox,
  FaMoneyBill,
  FaCodeBranch,
} from "react-icons/fa";
import { IoQrCodeSharp } from "react-icons/io5";
import { AiFillApi } from "react-icons/ai";
import { Nav } from "react-bootstrap";
import _ico from "../../../componets/_icon";

export default class SideBar extends React.Component {
  state = {
    default: [
      {
        title: "Servis21",
        itemId: "/apps",
        elemBefore: () => <FaDiceD6 />,
        subNav: [
          {
            title: "Příjem zásilek",
            itemId: "/internal/service/reception",
            elemBefore: () => <FaInbox />,
          },
          {
            title: "Ceníky",
            itemId: "/internal/service/priceList",
            elemBefore: () => <FaMoneyBill />,
          },
          {
            title: "QR Kódy ND",
            itemId: "/internal/service/ItemQr",
            elemBefore: () => <IoQrCodeSharp />,
          },
        ],
      },
      {
        title: "Integrace",
        itemId: "/integraction",
        elemBefore: () => <FaCodeBranch />,
        subNav: [
          {
            title: "Alcatel SCS",
            itemId: "/internal/serviceapi/alcatelscs",
            elemBefore: () => <AiFillApi />,
          },
          {
            title: "DPD GeoAPI",
            itemId: "/internal/serviceapi/dpdgeoapi",
            elemBefore: () => <AiFillApi />,
          },
          {
            title: "DPD-SK API",
            itemId: "/internal/serviceapi/dpdskapi",
            elemBefore: () => <AiFillApi />,
          },
          {
            title: "INTIME",
            itemId: "/internal/serviceapi/intimeapi",
            elemBefore: () => <AiFillApi />,
          },
          {
            title: "Partners API",
            itemId: "/internal/serviceapi/partnersapi",
            elemBefore: () => <AiFillApi />,
          },
          {
            title: "Samsung I-GSPN",
            itemId: "/internal/serviceapi/samsungigspn",
            elemBefore: () => <AiFillApi />,
          },
          {
            title: "Alza API",
            itemId: "/internal/serviceapi/alzaapi",
            elemBefore: () => <AiFillApi />,
          },
          {
            title: "T-Mobile HIRR",
            itemId: "/internal/serviceapi/tmobilehirr",
            elemBefore: () => <AiFillApi />,
          },
          {
            title: "O2 B2B Arsenal",
            itemId: "/internal/serviceapi/o2b2barsenal",
            elemBefore: () => <AiFillApi />,
          },
          {
            title: "O2-CZ",
            itemId: "/internal/serviceapi/o2cz",
            elemBefore: () => <AiFillApi />,
          },
          {
            title: "O2 FS",
            itemId: "/internal/serviceapi/o2fs",
            elemBefore: () => <AiFillApi />,
          },
          {
            title: "VSP Data",
            itemId: "/internal/serviceapi/vspdata",
            elemBefore: () => <AiFillApi />,
          },
        ],
      },
      {
        title: "Administrace",
        itemId: "/administration",
        elemBefore: () => <FaUsers />,
        subNav: [],
      },
    ],
    items: [
      {
        title: "Novinky",
        itemId: "/internal/news",
        elemBefore: () => <FaWpforms />,
      },
      {
        title: "Dashboard",
        itemId: "/internal/dashboard",
        elemBefore: () => <FaTachometerAlt />,
      },
      {
        title: "Facilities",
        itemId: "/internal/facilities",
        elemBefore: () => <FaIdBadge />,
      },
      {
        title: "Docházka",
        itemId: "/internal/attendance",
        elemBefore: () => <FaCalendarAlt />,
      },
      {
        title: "Mzdy",
        itemId: "/internal/wages",
        elemBefore: () => <FaMoneyBill />,
      },
      {
        title: "Školící systém",
        itemId: "/training",
        elemBefore: () => <FaUserGraduate />,
      },
      {
        title: "Moje poznámky",
        itemId: "/mybook",
        elemBefore: () => _ico({ icon: "faregclipboard" }),
      },
    ],
  };

  componentDidMount() {
    /* Načtení podle uživatele */
    
    this.props.user.auth
      .sort((a, b) => (a.parentId > b.parentId ? 1 : -1))
      .map((e, idx) => {
        if (e.parentId === null) {
          this.state.items.push({
            value: e.value,
            title: e.menuLabel,
            itemId: "null_" + idx,
            elemBefore: () => _ico({ icon: e.menuIcon }),
          });
        } else {
          for (var i = 0; i < this.state.items.length; i++) {
            if (this.state.items[i].value !== undefined) {
              if (this.state.items[i].value === e.parentId) {
                var nsn = this.state.items[i].subNav === undefined ? [] : this.state.items[i].subNav;
                nsn.push(
                  {
                    title: e.menuLabel,
                    itemId: e.route,
                    elemBefore: () => _ico({ icon: e.menuIcon }),
                  }
                );
                this.state.items[i] = {...this.state.items[i], subNav: nsn};
              }
            }
          }
        }
      });
  }

  render() {
    return (
      <Nav className="c-sidenav" id="sidenav">
        <Navigation
          activeItemId={this.props.getLocation.pathname}
          onSelect={({ itemId }) => {
            if (itemId.split("_")[0] !== "null") {
              this.props.navbarClick();
              this.props.setNavigate(itemId);
            }
          }}
          items={this.state.items}
        />
      </Nav>
    );
  }
}
